<template>
    <div :style="style">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    // import { ref, reactive, onMounted, defineProps, withDefaults } from 'vue'
    import { ref, reactive, onMounted } from 'vue'
    import {onResize} from "../../..";

    const props = withDefaults(defineProps<{
        over: number
    }>(), {
        over: 120
    });

    const style = ref<{
        height: string
    }>({
        height: '0'
    });

    onMounted(() => {
        computedViewHeight();
        // 注册视图大小改变事件
        onResize(() => {
            computedViewHeight();
        })
    });

    // 计算视图高度
    function computedViewHeight() {
        style.value.height = `${(document.documentElement.clientHeight || document.body.clientHeight) - props.over}px`;
    }


</script>

<style lang="scss">
    body {
        height: 100%;
    }
</style>
